export enum TrialAvailability {
    // Not visible at all
    NotAvailable,

    // Visible, but locked
    AvailableButBlocked,

    // Visible and available
    Available,
}
